var map = {
	"./algodao.svg": "9044",
	"./cafe.svg": "42ba",
	"./cana.svg": "faed",
	"./milho-selecionado.svg": "1762",
	"./milho.svg": "c206",
	"./outros.svg": "ce95",
	"./soja-selecionado.svg": "4158",
	"./soja.svg": "809e",
	"./trigo.svg": "aa11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed3e";